/**
 * Product Template 1 — Consolidated JS
 * IIFE to avoid global namespace pollution
 */
(function () {
  'use strict';

  /* ==========================================================================
     Easysize Autoclick
     ========================================================================== */

  function initEasysizeAutoclick() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('autoclick') === 'easysize') {
      setTimeout(function () {
        var btn = document.getElementById('easysize_button');
        if (btn) btn.click();
      }, 3000);
    }
  }

  /* ==========================================================================
     Delivery Countdown Timer
     ========================================================================== */

  function initDeliveryTimer() {
    var deliveryDayEl = document.getElementById('delivery-day');
    if (!deliveryDayEl) return;

    var daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var today = new Date();
    var deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 4);
    deliveryDayEl.innerText = daysOfWeek[deliveryDate.getDay()];

    var hours = 24;
    var minutes = 0;
    var seconds = 0;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      if (seconds === 0) {
        if (minutes === 0) {
          if (hours === 0) {
            clearInterval(timerInterval);
            return;
          }
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          minutes--;
          seconds = 59;
        }
      } else {
        seconds--;
      }

      var timerEl = document.getElementById('countdown-timer');
      if (timerEl) {
        timerEl.innerText = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }
    }

    tick();
    var timerInterval = setInterval(tick, 1000);
  }

  /* ==========================================================================
     Laces Product ATC Guard
     ========================================================================== */

  function initLacesGuard() {
    var addToCartButtons = document.querySelectorAll('[id^="AddToCart-"]');
    addToCartButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        var productType = this.getAttribute('data-product-type');
        if (productType === 'Laces') {
          event.preventDefault();
          var errorMsg = document.getElementById('errorMessage');
          if (errorMsg) errorMsg.style.display = 'block';
        }
      });
    });
  }

  /* ==========================================================================
     Variant Selection Validation
     Prevents form submission when no variant has been selected (e.g. preorder
     / custom-dropdown products that start with an empty placeholder option).
     Runs in the capture phase so it fires before the theme.js AJAX handler.
     ========================================================================== */

  function initVariantValidation() {
    document.querySelectorAll('[id^="AddToCart-"]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        var form = btn.closest('form[id^="AddToCartForm-"]');
        if (!form) return;

        var idField = form.querySelector('select[name="id"], input[name="id"]');
        if (!idField || !idField.value || idField.value === '') {
          event.preventDefault();
          event.stopImmediatePropagation();

          var errEl = form.querySelector('.variant-required-error');
          if (errEl) {
            errEl.removeAttribute('hidden');
            setTimeout(function () { errEl.setAttribute('hidden', ''); }, 3000);
          }
        }
      }, true); // capture phase — runs before the bubble-phase form submit handlers
    });
  }

  /* ==========================================================================
     Breadcrumb Collection Updater
     ========================================================================== */

  function initBreadcrumbUpdater() {
    setTimeout(function () {
      var historyList = [];
      try {
        historyList = JSON.parse(localStorage.getItem('shopify_recent_history')) || [];
      } catch (e) {
        return;
      }

      var candidateUrl = historyList[1] || null;
      if (!candidateUrl) return;
      if (candidateUrl.indexOf('/collections/') === -1) return;

      var match = candidateUrl.match(/collections\/([^\/\?\#]+)/);
      if (!match) return;

      var lastCollectionHandle = decodeURIComponent(match[1]);
      var collectionsEl = document.getElementById('pdp-collections-data');
      var productCollections = collectionsEl ? JSON.parse(collectionsEl.textContent) : [];
      var matched = productCollections.find(function (c) {
        return c.handle === lastCollectionHandle;
      });
      if (!matched) return;

      document.querySelectorAll('.breadcrumb-last-collection').forEach(function (el) {
        el.textContent = matched.title;
        el.href = window.location.origin + '/collections/' + matched.handle;
        el.style.display = 'inline-block';
      });

      document.querySelectorAll('.breadcrumb-arrow').forEach(function (arrow) {
        arrow.style.display = 'inline-block';
      });
    }, 80);
  }

  /* ==========================================================================
     Rotating Section Slider
     ========================================================================== */

  function initRotatingSection() {
    var container = document.querySelector('.rotating-section');
    if (!container) return;

    var containerWidth = container.scrollWidth;
    var viewportWidth = container.clientWidth;
    var startPosition = 0;

    function slide() {
      startPosition -= 1;
      if (Math.abs(startPosition) >= containerWidth) {
        startPosition = viewportWidth;
      }
      container.style.transform = 'translateX(' + startPosition + 'px)';
      requestAnimationFrame(slide);
    }

    slide();
  }

  /* ==========================================================================
     Sticky Position Handler
     ========================================================================== */

  function initStickyPosition() {
    if (window.innerWidth < 768) return;

    var sticky = document.querySelector('.photos-sticky');
    var div = document.querySelector('.product-single__info-wrapper');
    if (!sticky || !div) return;

    function updateStickyPosition() {
      var totalHeight = div.offsetHeight - window.innerHeight;
      sticky.style.top = '-' + totalHeight + 'px';
    }

    // Calculate once on load, then only on window resize.
    // Intentionally NOT observing DOM mutations so opening collapsible rows
    // does not cause the sticky image section to jump or extend scroll length.
    updateStickyPosition();
    window.addEventListener('resize', updateStickyPosition);
  }

  /* ==========================================================================
     Size Guide Modal z-index Handler
     ========================================================================== */

  function initSizeGuideModalZIndex() {
    var header = document.querySelector('#shopify-section-header');
    var openBtn = document.querySelector('.dev_open_size_guide_modal');
    var closeBtn = document.querySelector('.dev_close_size_guide_modal');

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        if (header) header.style.zIndex = '0';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (header) {
          setTimeout(function () {
            header.style.zIndex = '999';
          }, 500);
        }
      });
    }
  }


  /* ==========================================================================
     Preorder Badge — Variant Change Update
     Updates .preorder-pdp-box visibility and shipping date when a variant is
     selected via the standard (non-preorder-dropdown) selector.
     ========================================================================== */

  function initPreorderBadgeUpdate() {
    // preorder-dropdown already handles badge updates for its own products
    if (document.querySelector('.preorder-variant-dropdown')) return;

    var dataScript = document.querySelector('[id^="PreorderVariantData-"]');
    if (!dataScript) return;

    var preorderData;
    try {
      preorderData = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var preorderBox = document.querySelector('.preorder-pdp-box');
    if (!preorderBox) return;

    var shippingDateEl = preorderBox.querySelector('.preorder-shipping-date');

    $(document).on('variantChange', function (e) {
      var variant = e.variant;
      if (!variant) return;

      var data = preorderData[String(variant.id)];
      if (!data) return;

      var isPreorder = data.isPreorder === true;
      var shipBy = data.shipBy || '';
      var windowStart = data.windowStart || '';
      var windowEnd = data.windowEnd || '';
      var hasShippingDates = !!(shipBy || (windowStart && windowEnd));
      var isActivePreorder = isPreorder && hasShippingDates;

      // Update badge
      if (isActivePreorder) {
        if (shippingDateEl) {
          shippingDateEl.textContent = shipBy
            ? 'Ships by ' + shipBy
            : 'Ships ' + windowStart + ' – ' + windowEnd;
        }
        preorderBox.style.display = '';
      } else {
        preorderBox.style.display = 'none';
      }

      // Update cart property hidden inputs
      var statusInput = document.querySelector('input[name="properties[_Status]"]');
      if (statusInput) statusInput.value = isActivePreorder ? 'Pre-order' : 'In Stock';

      var preorderDateInput = document.querySelector('input[name="properties[_Preorder_Date]"]');
      if (preorderDateInput) preorderDateInput.value = (isActivePreorder && shipBy) ? (data.shipByRaw || '') : '';

      var estShippingInput = document.querySelector('input[name="properties[Estimated shipping]"]');
      if (estShippingInput) estShippingInput.value = (isActivePreorder && shipBy) ? (data.shipByCart || '') : '';

      var windowInput = document.querySelector('input[name="properties[Shipping window]"]');
      if (windowInput) {
        windowInput.value = (isActivePreorder && windowStart && windowEnd)
          ? 'from ' + (data.windowStartCart || '') + ' to ' + (data.windowEndCart || '')
          : '';
      }
    });
  }

  /* ==========================================================================
     Init on DOMContentLoaded
     ========================================================================== */

  document.addEventListener('DOMContentLoaded', function () {
    initEasysizeAutoclick();
    initDeliveryTimer();
    initLacesGuard();
    initVariantValidation();
    initBreadcrumbUpdater();
    initRotatingSection();
    initStickyPosition();
    initSizeGuideModalZIndex();
    initPreorderBadgeUpdate();
  });
})();
